import { api } from "../index";
import notification from "@/ApiConstance/toast";

export default {
  async AllBookings() {
    return await api.get("/allbookings");
  },
};
